import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import WaiverDisplay from '../display/WaiverDisplay';
import printJS from 'print-js';
import PrintIcon from '@mui/icons-material/Print';

export default function WaiverPreview({ open, onClose, waiver = null }) {
  const handleClose = () => {
    onClose();
  };

  const handlePrint = () => {
    printJS({
      printable: 'print-section', // ID of the element to print
      type: 'html',
      targetStyles: ['*'], // include all CSS styles
    });
  };

  if (!waiver) return null;

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="md" disableRestoreFocus>
      <DialogTitle>Waiver Preview</DialogTitle>
      <DialogContent dividers>
        <WaiverDisplay
          id={waiver.id}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handlePrint}>
          <PrintIcon />
        </Button>
        <div style={{ flex: '1 0 0' }} />
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
